<template>
  <div>
    <e-dialog :config="openEditConfig" :btns="openEditBtns">
      <template slot="content">
        <e-tabs ref="tabs" :params="tabActive" :tabs="tabs" @change="change"></e-tabs>
        <div class="search-box">
          <!-- <e-search @search="getList" @reset="reset" v-model="tableFilters"></e-search> -->
        </div>
        <e-table
          ref="roleTable"
          :options="options"
          :columns="columns"
          :operates="operates"
          @selectionChangeHandle="selectionChangeHandle"
          @afterCurrentPageClick="afterCurrentPageClickHandle"
        />
      </template>
    </e-dialog>
  </div>
</template>

<script>
import publicUserService from '@manager/api/agencyUser/public-user-service';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      openEditConfig: {
        title: '角色详情',
        width: '900px',
        visible: false,
        hasConfirm: false,
        hasCancel: false,
        hasBtn: true,
      },
      openEditBtns: [
        {
          label: '取消',
          class: 'public-el-button-default',
          method: () => {
            this.tabActive = 'allrole';
            this.openEditConfig.visible = false;
          },
          show: true,
        },
        {
          label: '批量分配',
          type: 'primary',
          class: 'public-el-button',
          method: () => {
            if (this.roleIds.length <= 0) {
              this.$message.warning('请勾选角色');
              return;
            }
            this.editUserRole();
          },
          show: true,
        },
      ],
      tabs: [
        {
          label: '未分配角色',
          name: 'allrole',
        },
        {
          label: '已分配角色',
          name: 'allocatedrole',
        },
      ],
      tabActive: 'allrole',
      options: {
        // 每页数据数
        pageSize: 10,
        loading: true,
        mutiSelect: true,
        hasIndex: false,
      },
      columns: [
        {
          prop: 'title',
          label: '角色用户名',
        },
        {
          prop: 'name',
          label: '角色名称',
        },
        {
          prop: 'type',
          label: '类型',
          render: (h, row) => {
            return this.formatDic(h, '角色类型', row['type']);
          },
        },
        {
          prop: 'description',
          label: '描述',
        },
      ],
      operates: {
        //表格操作栏
        width: 50,
        list: [
          {
            id: '1',
            label: '分配',
            show: true,
            method: (key, row) => {
              // console.log(row);
              if (this.roleIds.length <= 0) {
                this.$message.warning('请勾选角色');
                return;
              }
              this.editUserRole();
            },
            showCallback: () => {
              return true;
            },
          },
        ],
      },
      tableFilters: [
        //条件查询
        {
          type: 'input',
          label: '角色显示名',
          placeholder: '请输入',
          key: 'title',
          value: '', // 接口传参 value 值
        },
      ],
      params: {
        current: 1, //当前页(大于0)
        size: 10, //每页数量
        orderField: 'ORDERS', //排序方式默认：ORDERS
        title: '', //角色显示名
      },
      parentData: {},
      bool: true, //1代表全部角色   2代表已分配角色
      roleIds: [],
      userId: '',
    };
  },
  methods: {
    open(parentData) {
      this.parentData = parentData;
      this.openEditConfig.visible = true;
      this.bool = true;
      this.openEditBtns[1].label = '批量分配';
      this.operates.list[0].label = '分配';
      this.roleList();
      this.bool = true;
      this.$nextTick(() => {
        this.$refs.tabs.data = this.tabs[0].name;
        this.roleList();
        this.roleLoginList();
      });
    },
    change(data) {
      //点击tab标签触发的方法
      this.params.current = 1;
      this.tabActive = data;
      if (this.tabActive === this.tabs[0].name) {
        //全部角色
        this.openEditBtns[1].label = '批量分配';
        this.operates.list[0].label = '分配';
        this.roleList();
        this.bool = true;
      } else {
        //已分配角色
        this.openEditBtns[1].label = '批量移除';
        this.operates.list[0].label = '移除';
        this.roleLoginList();
        this.bool = false;
      }
    },
    //改变分页查询
    afterCurrentPageClickHandle(value) {
      this.params.current = value;
      if (this.tabActive === this.tabs[0].name) {
        //全部角色
        this.roleList();
      } else {
        //已分配角色
        this.roleLoginList();
      }
    },
    //条件查询
    getList(data) {
      this.params.current = 1;
      this.params.title = data.title;
      if (this.tabActive === this.tabs[0].name) {
        //全部角色
        this.roleList();
      } else {
        //已分配角色
        this.roleLoginList();
      }
    },
    //清空条件
    reset() {
      this.params.current = 1;
      this.params.title = '';
      if (this.tabActive === this.tabs[0].name) {
        //全部角色
        this.roleList();
      } else {
        //已分配角色
        this.roleLoginList();
      }
    },
    selectionChangeHandle(val) {
      let roleIds = [];
      val.forEach((item) => {
        roleIds.push(item.id);
      });
      this.roleIds = roleIds;
    },
    roleList() {
      //全部角色
      publicUserService.getRoleList(this.params).then((res) => {
        if (res.success === true) {
          if (res.data.records && res.data.records.length > 0) {
            this.$refs.roleTable.setTableList(res.data.records);
          } else {
            this.$refs.roleTable.setTableList([]);
            this.$refs.roleTable.setTotal(0);
            return;
          }
          this.$refs.roleTable.setTotal(res.data.total); //设置数据的总数
          this.$refs.roleTable.setPageSize(res.data.size); //设置每一页的显示条数
          this.$refs.roleTable.setCurrentPage(res.data.current);
        } else {
          this.$refs.roleTable.setTableList([]);
          this.$refs.roleTable.setTotal(0);
          this.$message.warning(res.message);
        }
      });
    },
    roleLoginList() {
      //已分配角色
      publicUserService.getByLoginName({ loginName: this.parentData.loginName}).then((res) => {
        if (res.success === true) {
          if (res.data) {
            this.userId = res.data.id;
            if (this.bool) {
              return;
            }
            this.$refs.roleTable.setTotal(0);
            if (res.data.roles && res.data.roles.length > 0) {
              this.$refs.roleTable.setTableList(res.data.roles);
            } else {
              this.$refs.roleTable.setTableList([]);
              return;
            }
          }
        } else {
          this.$refs.roleTable.setTableList([]);
          this.$refs.roleTable.setTotal(0);
          this.$message.warning(res.message);
        }
      });
    },
    //数据字典转换
    formatDic(h, column, row) {
      const dicLabel = this.$store.getters.getLabelDicByTypeAndValue(column, row);
      return h('span', {
        domProps: {
          innerHTML: dicLabel,
        },
      });
    },
    //修改角色
    editUserRole() {
      publicUserService
        .updateUserRole({
          userId: this.userId,
          roleIds: this.roleIds.join(','),
          bool: this.bool,
        })
        .then((res) => {
          if (res.success === true) {
            this.params.current = 1;
            if (this.tabActive === this.tabs[0].name) {
              //全部角色
              this.$message.success('分配成功');
              this.roleList();
            } else {
              //已分配角色
              this.$message.success('移除成功');
              this.roleLoginList();
            }
          } else {
            this.$message.warning(res.message);
          }
        });
    },
  },
  computed: {
    ...mapGetters(['dictionary']),
  },
};
</script>
>

<style lang="scss" scoped>
.search-box {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 560px;
  /deep/.el-input[data-v-60586776] {
    width: 250px !important;
  }
}
/deep/.el-dialog .el-dialog__footer {
  padding-bottom: 20px;
}
/deep/.el-table__body-wrapper {
  height: 280px !important;
}
/deep/[data-v-675b737a] .el-dialog .el-dialog__body {
  max-height: 590px;
  padding: 35px 50px 0 50px;
}
/deep/.el-dialog {
  margin-top: 10vh !important;
}
/deep/ .el-table__header-wrapper {
  /deep/ .el-table__header {
    /deep/ .el-checkbox {
      display: inline-block !important;
    }
  }
}
</style>
>
